/** Dev: same-origin `/api` via Vite proxy. Prod: public HTTPS API. */
const raw = import.meta.env.VITE_API_URL as string | undefined;

export const API_BASE =
  typeof raw === "string" && raw.trim().length > 0
    ? raw.replace(/\/$/, "")
    : import.meta.env.DEV
      ? ""
      : "https://worldvelopers.com/3dash";

export function apiUrl(path: string) {
  return `${API_BASE}${path}`;
}
